// extracted by mini-css-extract-plugin
export default {"container":"XB-z","modal":"YB-z","dimensions":"ZB-z","brandName":"_B-z","productName":"aC-z","labelValue":"bC-z","recipientEmail":"cC-z","recommendedFit":"dC-z","hiddenField":"eC-z"};